<form [formGroup]='controlesRiesgoGroup' autocomplete="off"  style="padding-top: 10px;">

    <div class='row justify-content-center'>
        <div class="col-6">
            <mat-form-field class="example-full-width" appearance="outline">
                <input aria-label="Fecha de Identificación" matInput [matDatepicker]="picker" formControlName='fechaCtrl' matInput
                    >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-label> Fecha de Identificación </mat-label>
            </mat-form-field>
        </div>
        <div class="col-sm-6">
            <mat-form-field appearance="outline">
                <mat-select formControlName='periodicidadCtrl' selected="selected" placeholder="Periodicidad"
                    >
                    <mat-option *ngFor="let item of periodicidad$ | async" [value]="item.id_periodicidad">
                        {{item.descripcion}}
                    </mat-option>
                </mat-select>
                <mat-label>Periodicidad</mat-label>
            </mat-form-field>
        </div>
        <div class="col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
                <input aria-label="Acciones a Seguir" formControlName='accionesSeguirCtrl' matInput type="text">
                <mat-label>Acciones a Seguir</mat-label>
            </mat-form-field>
        </div>
        <div class="col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
                <input aria-label="Responsable" formControlName='responsableRecursoCtrl' matInput type="text">
                <mat-label>Responsable</mat-label>
            </mat-form-field>
        </div>
    </div>

    <div class='row justify-content-end'>
        <div class='col-auto mr-auto'>
            <button mat-button matStepperPrevious class="btn btn-success">
                <i class='material-icons'> arrow_back_ios </i> Anterior
            </button>
        </div>
        <div class='col-auto'>
            <button mat-button matStepperNext [disabled]="controlesRiesgoGroup.invalid" class="btn btn-info"
            (click)="guardarRiesgo()">
                Guardar<i class='material-icons'> arrow_forward_ios </i>
            </button>
        </div>

    </div>

</form>
